var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrowser = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#browser_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "browser_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.667,
  height: 14.667,
  x: 0.667,
  y: 1.542,
  rx: 0.667
})), /*#__PURE__*/React.createElement("rect", {
  width: 14.667,
  height: 14.667,
  x: 0.667,
  y: 1.542,
  stroke: "#C1A36E",
  strokeWidth: 2,
  mask: "url(#browser_svg__b)",
  rx: 0.667
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  d: "M1.333 6.208H15"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  d: "M3.167 4.208h.666M5.833 4.208H6.5M8.5 4.208h.667"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "browser_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .875h16v16H0z"
})))));
SvgBrowser.viewBox = '0 0 16 17';
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrowser);
export default ForwardRef;